module.exports = __webpack_public_path__ + "img/5.a8e81fe3.png";